export default __webpack_public_path__ + "static/media/Bhojpuri_fin_f.773eec51.wav";